export default "__VITE_ASSET__6b47593a__"